<app-common-modal-wrapper
  saveBtnText="Save"
  icon=""
  [header]="header"
  [closeBtnText]="closeBtnText"
  [formGroup]="form"
  [isLoading]="isLoading"
  (submitModal)="confirm()"
  (close)="close()"
>
  <div class="d-flex flex-column gap-16">
    @if (showActionRequiredMessage) {
      <div class="form-group">

        <div class="text-center color-red mb-2">
          <b>ACTION REQUIRED</b>
        </div>

        <div>
          To receive payment reminders, please provide your billing contact details.
        </div>
      </div>
    }

    @if (!onlyBillingContact) {
      <app-checkbox
        label="Billing Contact is same as Signing Contact"
        formControlName="areContactsSame"
      />
    }

    @if (!onlyBillingContact) {
      <app-contacts-select
        formControlName="signingContactId"
        [label]="signingContactLabel"
        [entityId]="company.entityId"
        [contacts]="contacts"
        (select)="onSigningContactSelected($event)"
        (contactCreated)="onContactCreated($event, form.controls.signingContactId)"
      />
    }

    <div [hidden]="form.controls.areContactsSame.value && !onlyBillingContact">
      <app-contacts-select
        formControlName="billingContactId"
        [label]="billingContactControlLabel"
        [entityId]="company.entityId"
        [contacts]="billingContacts"
        [allowAddNoRelationshipNewContact]="true"
        (contactCreated)="onContactCreated($event, form.controls.billingContactId)"
        (noRelationshipContactCreated)="onBillingContactCrated($event)"
      />
    </div>

    @if (!showActionRequiredMessage && !form.untouched && form.errors) {
      <app-validation-error
        [control]="form"
        [customErrors]="customErrors"
      />
    }
  </div>
</app-common-modal-wrapper>
